<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="加工单列表"
      id-key="UserId"
      @close-saved="$emit('close-saved')"
      
    >

        <list ref="list" :consumablesType=1 :temp-params="{Statuses: [3,4,5], ProductionType: 0, OrderType}"  	></list>  

        <div slot="footer">
          <el-button type="primary" @click="saved">保存</el-button>
       </div>
      
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import list from "@/views/business/stock/workList/index";



// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    list,
  },
  props: {
    OrderType: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    saved(){
      let list = this.$refs.list.list;
      let subList = this.$refs.list.subList;
      this.$emit('saved', {
        list,
        subList,
      });
      this.close();
    }
  }
  
};
</script>
